import DGXSpark from "assets/img/jpg/dgx-spark.jpg";
import DGXStation from "assets/img/jpg/dgx-station.jpg";
import DGXDataCenter from "assets/img/png/dgxDatacenter.png";
import { isDgxSpark, isDgxStation } from "./instanceTypes";

/**
 * Gets the hardware image based on the provider or instance type name
 */
export function getHardwareImage(nameOrId?: string) {
  if (!nameOrId) return DGXDataCenter;

  if (isDgxSpark(nameOrId)) {
    return DGXSpark;
  } else if (isDgxStation(nameOrId)) {
    return DGXStation;
  } else if (
    nameOrId.toLowerCase().includes("data center") ||
    nameOrId.toLowerCase().includes("datacenter")
  ) {
    return DGXDataCenter;
  }
  return DGXDataCenter; // Default
}

